/** @format */
import { theme as baseTheme } from '@mpb-com/feather/theme';

/**
 * The Toucan theme
 */

export const theme = {
    typography: baseTheme.typography,
};
